<script setup lang="ts">
import { computed } from 'vue';
import { RBCCellTypeStats } from '@/types/rbc';
import { getStatusTheme } from '@/utils/progressUtils';

const props = defineProps<{
  progress: number;
  status: RBCCellTypeStats['status'];
}>();

const theme = computed(() => getStatusTheme(props.progress, props.status));
</script>

<template>
  <span
    class="badge rounded-pill px-3 py-2 fw-bold shadow-sm"
    :class="theme.badgeClass"
  >
    {{ theme.label }}
  </span>
</template>

<style scoped>
.badge {
  font-size: 0.7rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  min-width: 100px;
  text-align: center;
}
.status-badge-success {
  background-color: #d1fae5;
  color: #065f46;
}
.status-badge-warning {
  background-color: #fef3c7;
  color: #92400e;
}
.status-badge-danger {
  background-color: #fee2e2;
  color: #991b1b;
}
.badge-secondary {
  background-color: #f3f4f6 !important;
  color: #374151 !important;
}
</style>
